<div class="d-flex align-items-center justify-content-center">
  <div class="container text-center">
    <div class="row text-start pb-5 mt-4">
      <div class="col-lg-7 col-md-6 mb-4 d-flex flex-column gap-3">

        <div class="card border-0 radius">
          <div class="card-body p-4">
            @if(testQuestionsData !== null ? testQuestionsData.length > 0 : false)
            {
            <h4 class="fw-bold color mb-4">{{profileData?.fullName}}'s Answers</h4>
            @for (test of testQuestionsData; track $index) {
            <div class="card shadow-sm border-question radius mb-4"
              [ngClass]="{ 'background-color': test.score === 0, 'background-color2': test.score === 0.5 }">
              <div class="card-body">
                <div class="row align-items-center">
                  <div class="col">
                    <h6 class="fw-bold color">{{$index +1}}. {{test.questionText}}</h6>
                    <p class="mb-0"><span class="underline">Answer:</span> {{test.userResponse}}</p>
                  </div>
                  <div class="col-auto d-flex align-items-center justify-content-center" style="min-width:90px;">
                    <p class="mb-0 color"><b>{{test.score}} point</b></p>
                  </div>
                  <div class="col-auto d-flex align-items-center justify-content-end gap-2" style="min-width:90px;">
                    @if (test.questionType === QuestionType.CodeCompletion || test.questionType ===
                    QuestionType.OpenEnded){
                    <button class="btn review" (click)="goToManualFeedback(test)">Review</button>
                    }
                  </div>

                </div>
              </div>
            </div>
            }
            } @else{
            <h4 class="fw-bold color mb-4 text-center">This job didn't have an assessment when the candidate applied, so
              no test results are available.</h4>
            }

          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="card border-0 radius">
          <div class="card-body p-4">

            <div class="d-flex align-items-center mb-4 justify-content-between">
              <h4 class="fw-bold color mb-0">{{profileData?.fullName}}</h4>
              <img class="icon ms-3" [src]="'data:image/png;base64,' + profileData?.image"
                alt="{{profileData?.fullName}}'s picture">
            </div>

            <div class="small">
              <h6 class="fw-bold mb-2">Biography:</h6>
              @if(!profileData?.bio) {
              <p class="mb-2">User did not provide a biography</p>
              }
              <p class="mb-2">{{profileData?.bio}}</p>
            </div>

            <hr class="divider">
            <h6 class="fw-bold mb-2">Contact details:</h6>
            <p>{{profileData?.email}}</p>
            <hr class="divider">
            <h6 class="fw-bold mb-2">Skills</h6>
            @if(profileData?.skills?.length === 0){
            <p>No skills added</p>
            }
            @else {
            <div class="d-flex flex-column gap-2 mb-4">
              @for (skill of profileData?.skills; track skill.id) {
              <div class="d-flex align-items-center gap-2 border p-2 rounded w-100 bg-light">
                <img class="size" [src]="badgeService.getBadgeIconForSkill(skill.name, profileData?.badges ?? [])" />
                <span class="fs-6 fw-semibold text-dark">
                  {{ skill.name }}
                </span>
              </div>
              }
            </div>
            }
            <hr class="divider">
            <div class="d-flex align-items-center justify-content-center">
              <div class="d-flex justify-content-between gap-4">
                <button class="btn btn-color-blue" (click)="acceptCandidate()">Accept candidate</button>
                <button class="btn btn-color-red" (click)="rejectCandidate()">Reject candidate</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>